import React from 'react'

export const ContentHeader = props => (
    <section className="content-header">{props.children}</section>
)